import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "codeTypeSelect",
    "trialSection",
    "percentageSection",
    "amountSection",
    "usageLimitSection",
    "usageLimitTypeSelect",
    "usageLimitInput",
    "enableUserLimitSelect",
    "userLimitSection",
    "currencyRow",
    "addCurrencyButton"
  ]

  connect() {
    this.toggleCodeTypeSections()
    this.toggleUsageLimitInput()
    this.toggleUserLimitSection()
  }

  toggleCodeTypeSections() {
    const value = this.codeTypeSelectTarget.value
    this._toggle(this.trialSectionTarget,      value === "trial")
    this._toggle(this.percentageSectionTarget, value === "percentage")
    this._toggle(this.amountSectionTarget,     value === "amount")
    this._toggle(this.usageLimitSectionTarget, value === "percentage" || value === "amount")
  }

  toggleUsageLimitInput() {
    const limited = this.usageLimitTypeSelectTarget.value === "limited"
    this._toggle(this.usageLimitInputTarget, limited)
  }

  toggleUserLimitSection() {
    const enabled = this.enableUserLimitSelectTarget.value === "true"
    this._toggle(this.userLimitSectionTarget, enabled)
  }

  addCurrency(event) {
    const currency = event.currentTarget.dataset.currency
    const row = this._currencyRow(currency)
    if (row) {
      row.classList.remove("hidden")
      const input = row.querySelector("input")
      if (input) input.focus()
    }
    this._toggle(this._addCurrencyButton(currency), false)
  }

  removeCurrency(event) {
    const currency = event.currentTarget.dataset.currency
    const row = this._currencyRow(currency)
    if (row) {
      row.classList.add("hidden")
      const input = row.querySelector("input")
      if (input) input.value = "0"
    }
    this._toggle(this._addCurrencyButton(currency), true)
  }

  _currencyRow(currency) {
    return this.currencyRowTargets.find((el) => el.dataset.currency === currency)
  }

  _addCurrencyButton(currency) {
    return this.addCurrencyButtonTargets.find((el) => el.dataset.currency === currency)
  }

  _toggle(element, show) {
    if (!element) return
    show ? element.classList.remove("hidden") : element.classList.add("hidden")
  }
}
